/* ==========================================================================
   ECOM X HEALTH — theme.js
   Sin dependencias. Compatible con el editor de temas de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  const EX = window.EcomX || {};

  /* ---------- Helpers ---------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || EX.moneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (number, precision, thousands, decimal) => {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };
    const match = format.match(placeholder);
    let value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  EX.formatMoney = formatMoney;

  function toast(msg) {
    const el = $('#EcomXToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  /* ---------- Drawers (menú y carrito) ---------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const focusable = $('button, a, input', d);
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  EX.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.dataset.drawerOpen === 'CartDrawer' && EX.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.drawerOpen);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
    const searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      e.preventDefault();
      const s = document.getElementById('HeaderSearch');
      if (s) {
        s.hidden = !s.hidden;
        if (!s.hidden) $('input', s).focus();
      }
    }
  });
  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Carrito AJAX ---------- */
  const Cart = {
    sections: ['cart-drawer'],
    async refreshCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      } catch (err) { /* noop */ }
    },
    renderSections(sections) {
      if (!sections) return;
      const html = sections['cart-drawer'];
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#CartDrawerInner');
      const current = document.getElementById('CartDrawerInner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      this.enhance();
    },
    // Resalta el producto recién agregado y carga sugeridos automáticos
    enhance() {
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return;
      if (this.lastAdded) {
        const item = drawer.querySelector(`.cd-item[data-variant-id="${this.lastAdded}"]`);
        if (item) { item.classList.add('is-new'); setTimeout(() => item.classList.remove('is-new'), 1800); }
        this.lastAdded = null;
      }
      const auto = drawer.querySelector('[data-upsell-auto]');
      if (!auto) return;
      fetch(`${EX.routes.root_url.replace(/\/$/, '')}/recommendations/products.json?product_id=${auto.dataset.upsellAuto}&limit=6&intent=related`)
        .then((r) => r.json())
        .then((json) => {
          const list = auto.querySelector('[data-upsell-list]');
          const products = (json.products || []).filter((p) => p.available).slice(0, 4);
          if (!products.length || !list) return;
          list.innerHTML = products.map((p) => {
            const v = p.variants.find((x) => x.available) || p.variants[0];
            const img = p.featured_image ? `<img src="${p.featured_image}${p.featured_image.indexOf('?') > -1 ? '&' : '?'}width=200" alt="" loading="lazy" width="200" height="200">` : '';
            const compare = p.compare_at_price > p.price ? ` <s>${formatMoney(p.compare_at_price)}</s>` : '';
            return `<div class="cd-up"><a href="${p.url}" class="cd-up__media">${img}</a><div class="cd-up__info"><a href="${p.url}" class="cd-up__title">${p.title}</a><span class="cd-up__price">${formatMoney(p.price)}${compare}</span></div><button type="button" class="cd-up__add" data-quick-add="${v.id}" aria-label="Agregar">+</button></div>`;
          }).join('');
          auto.hidden = false;
        })
        .catch(() => {});
    },
    async add(formData) {
      formData.append('sections', this.sections.join(','));
      formData.append('sections_url', window.location.pathname);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: formData
      });
      const data = await res.json();
      if (data.status && data.status !== 200) throw new Error(data.description || data.message || 'Error');
      return data;
    },
    async change(line, quantity) {
      const drawer = document.getElementById('CartDrawer');
      if (drawer) drawer.classList.add('is-loading');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity, sections: this.sections, sections_url: window.location.pathname })
        });
        const data = await res.json();
        if (data.status && data.status !== 200) {
          toast(data.description || 'No se pudo actualizar');
        } else {
          this.renderSections(data.sections);
        }
      } finally {
        if (drawer) drawer.classList.remove('is-loading');
        this.refreshCount();
      }
    },
    afterAdd(data) {
      this.lastAdded = data && (data.variant_id || (data.items && data.items[0] && data.items[0].variant_id));
      if (EX.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        this.renderSections(data.sections);
        this.refreshCount();
        openDrawer('CartDrawer');
      } else {
        window.location.href = EX.routes.cart_url;
      }
    }
  };
  EX.Cart = Cart;

  // Cambios de cantidad dentro del carrito lateral
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (btn) {
      e.preventDefault();
      const line = parseInt(btn.dataset.line, 10);
      const input = $(`[data-cart-input][data-line="${line}"]`);
      let qty = parseInt(input ? input.value : 1, 10);
      qty = btn.dataset.cartQty === 'plus' ? qty + 1 : Math.max(0, qty - 1);
      Cart.change(line, qty);
      return;
    }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      Cart.change(parseInt(rm.dataset.line, 10), 0);
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-input]');
    if (input && input.closest('#CartDrawer')) {
      Cart.change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    }
  });

  // Agregar rápido desde tarjetas / upsell
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    const original = btn.innerHTML;
    btn.textContent = 'Agregando…';
    try {
      const fd = new FormData();
      fd.append('id', btn.dataset.quickAdd);
      fd.append('quantity', btn.dataset.quantity || 1);
      const data = await Cart.add(fd);
      Cart.afterAdd(data);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.disabled = false;
      btn.innerHTML = original;
    }
  });

  /* ---------- Selectores de cantidad ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    e.preventDefault();
    const input = $('input', b.closest('.qty'));
    const min = parseInt(input.min || 1, 10);
    let v = parseInt(input.value, 10) || min;
    v = b.dataset.qtyBtn === 'plus' ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ==========================================================================
     PRODUCTO
     ========================================================================== */
  class ProductSection {
    constructor(root) {
      this.root = root;
      const json = $('[data-product-json]', root);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('form[data-product-form]', root);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      this.qtyInput = $('[data-product-qty]', root);
      this.variant = this.product.variants.find((v) => String(v.id) === String(this.idInput && this.idInput.value)) || this.product.variants[0];
      this.offersMode = null;

      this.bindVariantPicker();
      this.bindOffers();
      this.bindGallery();
      this.bindForm();
      this.bindSticky();
      this.updateUI(false);
    }

    /* Variantes */
    bindVariantPicker() {
      this.root.addEventListener('change', (e) => {
        if (!e.target.closest('[data-variant-picker]')) return;
        const options = $$('[data-variant-picker] [data-option-index]', this.root).reduce((acc, el) => {
          if (el.tagName === 'SELECT') acc[el.dataset.optionIndex] = el.value;
          else if (el.checked) acc[el.dataset.optionIndex] = el.value;
          return acc;
        }, []);
        const match = this.product.variants.find((v) => v.options.every((o, i) => options[i] === undefined || o === options[i]));
        if (match) {
          this.variant = match;
          this.updateUI(true);
        } else {
          this.setButton(false, 'No disponible');
        }
        $$('[data-selected-value]', this.root).forEach((el) => {
          el.textContent = options[el.dataset.selectedValue] || '';
        });
      });
    }

    /* Bundles conectados por ID de variante */
    bindOffers() {
      const wrap = $('[data-offers]', this.root);
      if (!wrap) return;
      this.offersWrap = wrap;
      this.offersMode = 'bundle';
      this.planInput = $('[data-selling-plan-input]', this.root);
      wrap.addEventListener('change', (e) => {
        const input = e.target.closest('input[name^="ecomx-offers-"]');
        if (input) this.applyBundle(input, true);
      });
      const checked = $('input[name^="ecomx-offers-"]:checked', wrap) || $('input[name^="ecomx-offers-"]:not(:disabled)', wrap);
      if (checked) { checked.checked = true; this.applyBundle(checked, false); }
    }

    applyBundle(input, pushState) {
      const followCurrent = input.dataset.follow === 'true';
      const v = followCurrent ? this.variant : this.product.variants.find((x) => String(x.id) === input.dataset.variantId);
      if (this.qtyInput) this.qtyInput.value = parseInt(input.dataset.qty, 10) || 1;
      if (this.planInput) {
        const plan = input.dataset.sellingPlan || '';
        this.planInput.value = plan;
        this.planInput.disabled = !plan;
      }
      if (v) { this.variant = v; this.updateUI(pushState); }
    }

    updateOffers() {
      if (!this.offersWrap) return;
      const v = this.variant;
      const mode = this.offersWrap.dataset.compareMode;
      const offers = $$('[data-offer]', this.offersWrap);
      // Solo recalcula las ofertas que siguen a la variante seleccionada (sin ID fijo)
      let baseUnit = null;
      offers.forEach((offer, idx) => {
        const input = $('input', offer);
        const qty = parseInt(input.dataset.qty, 10) || 1;
        const units = parseInt(input.dataset.units, 10) || qty;
        let total = parseInt(input.dataset.total, 10);
        if (input.dataset.follow === 'true') {
          total = v.price * qty;
          input.dataset.total = total;
        }
        if (idx === 0) baseUnit = total / units;
        if (input.dataset.follow !== 'true') return;
        const compare = mode === 'base' && baseUnit ? Math.round(baseUnit * units) : Math.max(v.compare_at_price || 0, v.price) * qty;
        const saved = compare - total;
        const set = (sel, txt) => { const el = $(sel, offer); if (el) el.textContent = txt; return el; };
        set('[data-offer-price]', formatMoney(total));
        set('[data-offer-unit]', formatMoney(Math.round(total / units)));
        if (input.dataset.months) set('[data-offer-month]', formatMoney(Math.round(total / parseInt(input.dataset.months, 10))));
        const c = set('[data-offer-compare]', formatMoney(compare));
        if (c) c.hidden = saved <= 0;
        const sv = set('[data-offer-save]', `Ahorrás ${formatMoney(saved)}`);
        if (sv) sv.hidden = saved <= 0;
        const pct = $('[data-offer-pct]', offer);
        if (pct) { pct.textContent = `-${Math.round((saved * 100) / compare)}%`; pct.hidden = saved <= 0; }
      });
    }

    updateUI(pushState) {
      const v = this.variant;
      if (!v) return;
      if (this.idInput) this.idInput.value = v.id;

      // Precio
      $$('[data-price-wrapper]', this.root).forEach((w) => {
        if (w.closest('.product-card')) return;
        const priceEl = $('[data-price]', w);
        const compareEl = $('[data-compare-price]', w);
        const badge = $('[data-price-badge]', w);
        const onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = `Ahorrás ${Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%`;
        }
        w.classList.toggle('price--sale', !!onSale);
      });

      // Cuotas
      $$('[data-installments]', this.root).forEach((el) => {
        const n = parseInt(el.dataset.installments, 10) || 1;
        $('[data-installment-amount]', el).textContent = formatMoney(Math.round(v.price / n));
      });

      // Sincroniza píldoras y selects con la variante
      v.options.forEach((val, i) => {
        $$(`[data-option-index="${i}"]`, this.root).forEach((el) => {
          if (el.tagName === 'SELECT') el.value = val;
          else el.checked = el.value === val;
        });
        $$(`[data-selected-value="${i}"]`, this.root).forEach((el) => (el.textContent = val));
      });

      // Si se cambia la variante desde el selector, marca el bundle que use esa variante
      if (this.offersWrap) {
        const checked = $('input[name^="ecomx-offers-"]:checked', this.offersWrap);
        if (checked && checked.dataset.follow !== 'true' && checked.dataset.variantId !== String(v.id)) {
          const match = $(`input[name^="ecomx-offers-"][data-variant-id="${v.id}"]`, this.offersWrap);
          if (match) {
            match.checked = true;
            if (this.qtyInput) this.qtyInput.value = parseInt(match.dataset.qty, 10) || 1;
          }
        }
      }

      // Botón
      this.setButton(v.available, v.available ? null : 'Agotado');

      // Imagen de la variante
      if (v.featured_media && pushState) this.goToMedia(v.featured_media.id);

      // URL
      if (pushState && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Stock
      $$('[data-stock]', this.root).forEach((el) => {
        const threshold = parseInt(el.dataset.threshold, 10) || 10;
        const qty = this.product.inventory ? this.product.inventory[v.id] : null;
        const text = $('[data-stock-text]', el);
        const low = qty !== null && qty !== undefined && qty > 0 && qty <= threshold;
        el.classList.toggle('stock--low', low || !v.available);
        if (text) {
          if (!v.available) text.textContent = 'Sin stock por el momento';
          else if (low) text.textContent = (el.dataset.lowText || '').replace('[qty]', qty);
          else text.textContent = el.dataset.inText || '';
        }
      });

      this.updateOffers();
      this.updateSticky();
    }

    setButton(enabled, text) {
      $$('[data-add-button]', this.root).forEach((btn) => {
        btn.disabled = !enabled;
        const label = $('[data-add-text]', btn);
        if (label) label.textContent = text || btn.dataset.defaultText;
      });
    }

    /* Galería */
    bindGallery() {
      this.track = $('[data-gallery-track]', this.root);
      if (!this.track) return;
      this.thumbs = $$('[data-gallery-thumb]', this.root);
      this.dots = $$('[data-gallery-dot]', this.root);
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.scrollTo(i)));
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.setActive(i);
        });
      }, { passive: true });
    }
    scrollTo(i) {
      if (!this.track) return;
      this.track.scrollTo({ left: this.track.clientWidth * i, behavior: 'smooth' });
      this.setActive(i);
    }
    setActive(i) {
      (this.thumbs || []).forEach((t, j) => t.classList.toggle('is-active', i === j));
      (this.dots || []).forEach((t, j) => t.classList.toggle('is-active', i === j));
    }
    goToMedia(mediaId) {
      if (!this.track) return;
      const slides = $$('[data-media-id]', this.track);
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(mediaId));
      if (i > -1) this.scrollTo(i);
    }

    /* Agregar al carrito */
    bindForm() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const buttons = $$('[data-add-button]', this.root);
        buttons.forEach((b) => b.classList.add('is-loading'));
        buttons.forEach((b) => (b.disabled = true));
        const err = $('[data-form-error]', this.root);
        if (err) err.hidden = true;
        try {
          const fd = new FormData(this.form);
          if (this.qtyInput && !fd.get('quantity')) fd.set('quantity', this.qtyInput.value);
          const data = await Cart.add(fd);
          Cart.afterAdd(data);
        } catch (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message);
        } finally {
          buttons.forEach((b) => b.classList.remove('is-loading'));
          this.setButton(this.variant.available, this.variant.available ? null : 'Agotado');
        }
      });
    }

    /* Botón fijo inferior */
    bindSticky() {
      this.sticky = $('[data-sticky-atc]', this.root);
      if (!this.sticky) return;
      const target = $('[data-add-button]', this.form) || this.form;
      if (!target) return;
      const io = new IntersectionObserver(([entry]) => {
        const passed = entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', !entry.isIntersecting && passed);
      });
      io.observe(target);
      const btn = $('[data-sticky-submit]', this.sticky);
      if (btn) btn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.submit();
      });
    }
    updateSticky() {
      if (!this.sticky) return;
      const qty = this.qtyInput ? parseInt(this.qtyInput.value, 10) || 1 : 1;
      let total = this.variant.price * qty;
      const checked = this.offersWrap ? $('input[name^="ecomx-offers-"]:checked', this.offersWrap) : null;
      if (checked && checked.dataset.total) total = parseInt(checked.dataset.total, 10);
      $$('[data-sticky-price]', this.sticky).forEach((el) => (el.textContent = formatMoney(total)));
      const v = $('[data-sticky-variant]', this.sticky);
      if (v) v.textContent = this.product.variants.length > 1 ? this.variant.title : '';
      const btn = $('[data-sticky-submit]', this.sticky);
      if (btn) btn.disabled = !this.variant.available;
    }
  }

  /* ==========================================================================
     COMPONENTES DE SECCIONES
     ========================================================================== */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach((bar) => {
      if (bar._init) return; bar._init = true;
      const items = $$('.announcement__item', bar);
      if (items.length < 2 || bar.classList.contains('announcement--marquee')) return;
      let i = 0;
      const speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  function initSliders(root) {
    $$('[data-slider]', root).forEach((wrap) => {
      if (wrap._init) return; wrap._init = true;
      const track = $('.slider', wrap);
      const prev = $('[data-slider-prev]', wrap);
      const next = $('[data-slider-next]', wrap);
      const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 20 : 300);
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      if (wrap.dataset.autoplay) {
        setInterval(() => {
          if (wrap.matches(':hover')) return;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
        }, (parseInt(wrap.dataset.autoplay, 10) || 5) * 1000);
      }
    });
  }

  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const end = new Date(el.dataset.end).getTime();
      if (isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        const set = (k, v) => { const x = $(`[data-cd="${k}"]`, el); if (x) x.textContent = pad(v); };
        const hasD = !!$('[data-cd="d"]', el);
        set('d', d); set('h', hasD ? h : h + d * 24); set('m', m); set('s', s);
        if (end - Date.now() <= 0 && el.dataset.hideOnEnd === 'true') {
          const sec = el.closest('.shopify-section');
          if (sec && !window.Shopify?.designMode) sec.hidden = true;
        }
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  function initBeforeAfter(root) {
    $$('[data-ba]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const range = $('.ba__range', el);
      const set = () => el.style.setProperty('--pos', range.value + '%');
      range.addEventListener('input', set);
      set();
    });
  }

  function initCounters(root) {
    const els = $$('[data-count-to]', root).filter((e) => !e._init);
    if (!els.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        io.unobserve(el);
        const target = parseFloat(el.dataset.countTo) || 0;
        const decimals = (el.dataset.countTo.split('.')[1] || '').length;
        const dur = 1600;
        const start = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = (target * eased).toFixed(decimals);
          el.textContent = Number(val).toLocaleString('es-AR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach((el) => { el._init = true; io.observe(el); });
  }

  function initVideos(root) {
    $$('[data-video-poster]', root).forEach((btn) => {
      if (btn._init) return; btn._init = true;
      btn.addEventListener('click', () => {
        const tpl = btn.parentElement.querySelector('template');
        if (!tpl) return;
        btn.replaceWith(tpl.content.cloneNode(true));
      });
    });
  }

  function initAnimations(root) {
    if (!document.body.classList.contains('animations-on')) return;
    if (window.Shopify && window.Shopify.designMode) {
      $$('[data-animate]', root).forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('[data-animate]:not(.is-in)', root).forEach((el) => io.observe(el));
  }

  function initFilters(root) {
    $$('[data-filter-form]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      form.addEventListener('change', (e) => {
        if (e.target.type === 'number') return;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    $$('[data-sort-select]', root).forEach((sel) => {
      if (sel._init) return; sel._init = true;
      sel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
  }

  function initProducts(root) {
    $$('[data-product-section]', root).forEach((el) => {
      if (el._product) return;
      el._product = new ProductSection(el);
    });
  }

  /* ---------- Secuencia 1-2-3 guiada por scroll ---------- */
  function initStory(root) {
    $$('[data-story]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const items = $$('[data-story-item]', el);
      const slides = $$('[data-story-slide]', el);
      const dots = $$('[data-story-dot]', el);
      if (!items.length) return;
      const setActive = (i) => {
        items.forEach((it, j) => it.classList.toggle('is-active', j === i));
        slides.forEach((sl, j) => sl.classList.toggle('is-active', j === i));
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        // Precarga la imagen siguiente para que el cambio sea instantáneo
        const next = slides[i + 1] && slides[i + 1].querySelector('img');
        if (next && next.loading === 'lazy') next.loading = 'eager';
      };
      if (window.Shopify && window.Shopify.designMode) {
        items.forEach((it) => it.classList.add('is-seen'));
      }
      // Revela cada paso al entrar en pantalla
      const reveal = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-seen'); reveal.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      // Marca como activo el paso que está en el centro de la pantalla
      const center = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(parseInt(e.target.dataset.storyItem, 10));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach((it) => { reveal.observe(it); center.observe(it); });
    });
  }
  document.addEventListener('shopify:block:select', (e) => {
    const it = e.target.closest && e.target.closest('[data-story-item]');
    if (it) it.classList.add('is-seen');
  });

  /* ---------- Puntos interactivos sobre imagen ---------- */
  function initHotspots(root) {
    $$('[data-hotspots]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const wrap = el.parentElement;
      const items = $$('[data-hotspot-item]', wrap);
      const open = (idx) => {
        $$('.hs', el).forEach((h, j) => h.classList.toggle('is-open', j === idx));
        items.forEach((it, j) => it.classList.toggle('is-active', j === idx));
      };
      el.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-hotspot]');
        if (!dot) { open(-1); return; }
        const idx = parseInt(dot.dataset.hotspot, 10);
        open(dot.parentElement.classList.contains('is-open') ? -1 : idx);
      });
      items.forEach((it) => it.addEventListener('click', () => open(parseInt(it.dataset.hotspotItem, 10))));
    });
  }

  /* ---------- Lightbox (carrusel de reseñas) ---------- */
  function lightbox(html) {
    let box = document.getElementById('EcomXLightbox');
    if (!box) {
      box = document.createElement('div');
      box.id = 'EcomXLightbox';
      box.className = 'lightbox';
      box.innerHTML = '<div class="lightbox__overlay" data-lb-close></div><div class="lightbox__panel" role="dialog" aria-modal="true"><button type="button" class="lightbox__close" data-lb-close aria-label="Cerrar">&times;</button><div class="lightbox__body"></div></div>';
      document.body.appendChild(box);
      box.addEventListener('click', (e) => { if (e.target.closest('[data-lb-close]')) closeLb(); });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape') closeLb(); });
    }
    function closeLb() { box.classList.remove('is-open'); $('.lightbox__body', box).innerHTML = ''; document.body.style.overflow = ''; }
    $('.lightbox__body', box).innerHTML = html;
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-lightbox]');
    if (!t) return;
    const tpl = document.querySelector(`[data-lightbox-content="${t.dataset.lightbox}"]`);
    if (tpl) lightbox(tpl.innerHTML);
  });

  /* ---------- Reseñas: filtro por estrellas + ver más ---------- */
  function initReviews(root) {
    $$('[data-reviews]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const per = parseInt(el.dataset.perPage, 10) || 4;
      const reviews = $$('[data-review]', el);
      const more = $('[data-reviews-more]', el);
      const bar = $('[data-review-active]', el);
      let shown = per, filter = 'all';
      const render = () => {
        const list = reviews.filter((r) => filter === 'all' || r.dataset.rating === filter);
        reviews.forEach((r) => (r.hidden = true));
        list.forEach((r, j) => (r.hidden = j >= shown));
        if (more) more.hidden = list.length <= shown;
        if (bar) {
          bar.hidden = filter === 'all';
          const lbl = $('[data-review-active-label]', bar);
          if (lbl) lbl.textContent = `${filter} estrellas`;
        }
        $$('[data-review-filter]', el).forEach((b) => b.classList.toggle('is-active', b.dataset.reviewFilter === filter));
      };
      el.addEventListener('click', (e) => {
        const f = e.target.closest('[data-review-filter]');
        if (f) { filter = f.dataset.reviewFilter === filter ? 'all' : f.dataset.reviewFilter; shown = per; render(); }
        if (e.target.closest('[data-reviews-more]')) { shown += per; render(); }
      });
      if (window.Shopify && window.Shopify.designMode) shown = 999;
      render();
    });
  }

  /* ---------- Pop-up de suscripción ---------- */
  function initPopup(root) {
    $$('[data-popup]', root).forEach((pop) => {
      if (pop._init) return; pop._init = true;
      const id = 'ecomx-popup-' + pop.dataset.popupId;
      const form = pop.closest('form');
      const design = window.Shopify && window.Shopify.designMode;
      const store = {
        get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
        set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
      };
      const open = () => {
        if (pop.classList.contains('is-open')) return;
        pop.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        const input = $('input[type="email"]', pop);
        if (input && window.matchMedia('(min-width: 750px)').matches) setTimeout(() => input.focus(), 300);
      };
      const close = () => {
        pop.classList.remove('is-open');
        document.body.style.overflow = '';
        if (!pop.classList.contains('is-success')) store.set(id, Date.now() + (parseInt(pop.dataset.days, 10) || 7) * 864e5);
      };
      pop._open = open;
      pop._close = close;
      pop.addEventListener('click', (e) => {
        if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
        const copy = e.target.closest('[data-popup-copy]');
        if (copy) {
          const code = $('[data-popup-code]', pop).textContent.trim();
          (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(
            () => { copy.textContent = '¡Copiado!'; },
            () => { copy.textContent = code; }
          );
        }
      });
      document.addEventListener('keyup', (e) => { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });

      // Envío sin recargar la página
      if (form) form.addEventListener('submit', async (e) => {
        const input = $('input[type="email"]', form);
        const err = $('[data-popup-error]', pop);
        const valid = input && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
        if (!valid) { e.preventDefault(); if (err) { err.textContent = 'Ingresá un email válido.'; err.hidden = false; } input && input.focus(); return; }
        e.preventDefault();
        if (err) err.hidden = true;
        const btn = $('[data-popup-submit]', pop);
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        try {
          const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
          if (res.url.indexOf('/challenge') > -1) { form.submit(); return; }
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const remoteErr = form.id ? doc.querySelector(`#${CSS.escape(form.id)} [data-popup-error]:not([hidden])`) : null;
          const ok = res.url.indexOf('customer_posted=true') > -1 || (res.ok && !remoteErr);
          if (ok) {
            pop.classList.add('is-success');
            store.set(id, 'subscribed');
          } else if (err) {
            err.textContent = remoteErr ? remoteErr.textContent.trim() : 'No pudimos registrar tu email. Probá de nuevo.';
            err.hidden = false;
          }
        } catch (ex) {
          form.submit();
        } finally {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        }
      });

      if (pop.classList.contains('is-success')) { store.set(id, 'subscribed'); document.body.style.overflow = 'hidden'; return; }
      if (design || pop.dataset.enabled !== 'true') return;
      const saved = store.get(id);
      if (saved === 'subscribed' || (saved && parseInt(saved, 10) > Date.now())) return;
      if (pop.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;

      const delay = parseInt(pop.dataset.delay, 10);
      if (!isNaN(delay)) setTimeout(open, delay * 1000);
      const pct = parseInt(pop.dataset.scroll, 10);
      if (pct > 0) {
        const onScroll = () => {
          const h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && (window.scrollY / h) * 100 >= pct) { open(); window.removeEventListener('scroll', onScroll); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      if (pop.dataset.exit === 'true') {
        document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) open(); });
      }
    });
  }
  document.addEventListener('shopify:section:select', (e) => {
    const pop = e.target.querySelector('[data-popup]');
    if (pop && pop._open) pop._open();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const pop = e.target.querySelector('[data-popup]');
    if (pop && pop._close) { pop.classList.remove('is-open'); document.body.style.overflow = ''; }
  });

  /* ---------- Galería de detalle + zoom ---------- */
  function initDetailGallery(root) {
    $$('[data-dgallery]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const track = $('[data-dg-track]', el);
      const slides = $$('[data-dg-slide]', el);
      const thumbs = $$('[data-dg-thumb]', el);
      const details = $$('[data-dg-detail]', el);
      const cur = $('[data-dg-current]', el);
      const tot = $('[data-dg-total]', el);
      if (!track || !slides.length) return;
      if (tot) tot.textContent = slides.length;
      if (slides.length < 2) el.classList.add('dg--single');
      let i = 0;
      const mark = (n) => {
        i = Math.max(0, Math.min(slides.length - 1, n));
        thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
        details.forEach((d, j) => d.classList.toggle('is-active', j === i));
        if (cur) cur.textContent = i + 1;
        const t = thumbs[i];
        if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
      const go = (n) => { track.scrollTo({ left: track.clientWidth * Math.max(0, Math.min(slides.length - 1, n)), behavior: 'smooth' }); mark(n); };
      thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.dgThumb, 10))));
      const prev = $('[data-dg-prev]', el), next = $('[data-dg-next]', el);
      if (prev) prev.addEventListener('click', () => go(i - 1));
      if (next) next.addEventListener('click', () => go(i + 1));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => mark(Math.round(track.scrollLeft / track.clientWidth)));
      }, { passive: true });

      // Zoom a pantalla completa con swipe
      const tpl = el.closest('.section') && $('[data-dg-lightbox]', el.closest('.section'));
      track.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-dg-zoom]');
        if (!btn || !tpl) return;
        const start = parseInt(btn.dataset.dgZoom, 10);
        const box = tpl.content.firstElementChild.cloneNode(true);
        const ltrack = $('[data-dgl-track]', box);
        const counter = $('[data-dgl-counter]', box);
        slides.forEach((sl) => {
          const img = $('img', sl);
          const fig = document.createElement('div');
          fig.className = 'dgl__slide';
          if (img) {
            const big = new Image();
            big.src = img.currentSrc || img.src;
            if (img.srcset) { big.srcset = img.srcset; big.sizes = '100vw'; }
            big.alt = img.alt || '';
            fig.appendChild(big);
          }
          ltrack.appendChild(fig);
        });
        const upd = () => { counter.textContent = `${Math.round(ltrack.scrollLeft / ltrack.clientWidth) + 1} / ${slides.length}`; };
        ltrack.addEventListener('scroll', upd, { passive: true });
        const close = () => { box.remove(); document.body.style.overflow = ''; document.removeEventListener('keyup', onKey); };
        const onKey = (ev) => {
          if (ev.key === 'Escape') close();
          if (ev.key === 'ArrowRight') ltrack.scrollBy({ left: ltrack.clientWidth, behavior: 'smooth' });
          if (ev.key === 'ArrowLeft') ltrack.scrollBy({ left: -ltrack.clientWidth, behavior: 'smooth' });
        };
        box.addEventListener('click', (ev) => { if (ev.target.closest('[data-dgl-close]') || ev.target === box) close(); });
        document.addEventListener('keyup', onKey);
        document.body.appendChild(box);
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => { ltrack.scrollLeft = ltrack.clientWidth * start; upd(); });
      });
    });
  }

  /* ---------- Pestañas de información ---------- */
  function initInfoTabs(root) {
    $$('[data-itabs]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const tabs = $$('[data-itab]', el);
      const panels = $$('[data-itab-panel]', el);
      const show = (n) => {
        tabs.forEach((t, j) => { t.classList.toggle('is-active', j === n); t.setAttribute('aria-selected', j === n); });
        panels.forEach((p, j) => { p.hidden = j !== n; p.classList.toggle('is-active', j === n); });
        const t = tabs[n];
        if (t && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
      tabs.forEach((t, j) => t.addEventListener('click', () => show(j)));
      el._show = show;
    });
  }
  document.addEventListener('shopify:block:select', (e) => {
    const tab = e.target.closest && e.target.closest('[data-itab]');
    if (tab) { const w = tab.closest('[data-itabs]'); if (w && w._show) w._show(parseInt(tab.dataset.itab, 10)); }
  });

  /* ---------- Batería que se descarga con el scroll ---------- */
  function initBattery(root) {
    $$('[data-battery]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const fill = $('[data-battery-fill]', el);
      const pct = $('[data-battery-pct]', el);
      const items = $$('[data-battery-item]', el);
      const from = parseFloat(el.dataset.from) || 100;
      const to = parseFloat(el.dataset.to) || 10;
      let ticking = false;
      const update = () => {
        ticking = false;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.8 - r.top) / (r.height + vh * 0.2)));
        const lvl = Math.round(from - (from - to) * p);
        if (fill) {
          fill.style.setProperty('--lvl', lvl + '%');
          fill.classList.toggle('is-low', lvl <= 25);
          fill.classList.toggle('is-mid', lvl > 25 && lvl <= 55);
        }
        if (pct) pct.textContent = lvl + '%';
        items.forEach((it, j) => it.classList.toggle('is-on', p >= (j + 0.5) / (items.length + 0.5)));
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      const io = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) window.addEventListener('scroll', onScroll, { passive: true });
        else window.removeEventListener('scroll', onScroll);
      });
      io.observe(el);
      update();
      const next = $('[data-scroll-next]', el);
      if (next && next.getAttribute('href') === '#') next.addEventListener('click', (e) => {
        e.preventDefault();
        const sec = el.closest('.shopify-section');
        const n = sec && sec.nextElementSibling;
        if (n) n.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ---------- Test "¿cuántas te pasan?" ---------- */
  function initQuiz(root) {
    $$('[data-quiz]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const opts = $$('[data-quiz-opt]', el);
      const count = $('[data-quiz-count]', el);
      const bar = $('[data-quiz-bar]', el);
      const msg = $('[data-quiz-msg]', el);
      const update = () => {
        const n = opts.filter((o) => o.classList.contains('is-on')).length;
        const total = opts.length || 1;
        if (count) { count.textContent = n; count.classList.remove('is-bump'); void count.offsetWidth; count.classList.add('is-bump'); }
        if (bar) bar.style.width = (n / total) * 100 + '%';
        if (msg) msg.textContent = n === 0 ? msg.dataset.m0 : n === total ? msg.dataset.m3 : n >= total / 2 ? msg.dataset.m2 : msg.dataset.m1;
        el.classList.toggle('has-picks', n > 0);
      };
      opts.forEach((o) => o.addEventListener('click', () => {
        o.classList.toggle('is-on');
        o.setAttribute('aria-pressed', o.classList.contains('is-on'));
        if (navigator.vibrate) navigator.vibrate(8);
        update();
      }));
    });
  }

  /* ---------- Despiece del producto ---------- */
  function initBreakdown(root) {
    $$('[data-breakdown]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const btn = $('[data-breakdown-toggle]', el);
      const set = (open) => {
        el.classList.toggle('is-open', open);
        if (!btn) return;
        btn.setAttribute('aria-expanded', open);
        $('[data-label-open]', btn).hidden = open;
        $('[data-label-close]', btn).hidden = !open;
      };
      if (btn) btn.addEventListener('click', () => set(!el.classList.contains('is-open')));
      // Se arma solo la primera vez que aparece en pantalla
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { el.classList.add('is-seen'); io.disconnect(); } }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  /* ---------- Tarjetas que se dan vuelta ---------- */
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-flip]');
    if (!card) return;
    card.classList.toggle('is-flipped');
    card.setAttribute('aria-pressed', card.classList.contains('is-flipped'));
  });

  /* ---------- Testimonios en video ---------- */
  function initVideoReviews(root) {
    $$('[data-video-open]', root).forEach((tile) => {
      if (tile._init) return; tile._init = true;
      const preview = $('video', tile);
      if (preview) {
        const io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting) { preview.preload = 'metadata'; preview.play().catch(() => {}); } else preview.pause();
        }, { threshold: 0.5 });
        io.observe(tile);
      }
      tile.addEventListener('click', () => {
        const tpl = tile.parentElement.querySelector('[data-video-full]');
        if (!tpl || !tpl.innerHTML.trim()) return;
        const box = document.createElement('div');
        box.className = 'vfull';
        box.innerHTML = `<button type="button" class="dgl__close" aria-label="Cerrar">&times;</button><div class="vfull__media">${tpl.innerHTML}</div>`;
        const close = () => { box.remove(); document.body.style.overflow = ''; };
        box.addEventListener('click', (ev) => { if (ev.target === box || ev.target.closest('.dgl__close')) close(); });
        document.body.appendChild(box);
        document.body.style.overflow = 'hidden';
        const v = $('video', box);
        if (v) { v.muted = false; v.play().catch(() => {}); }
      });
    });
  }

  /* ---------- Carga progresiva de toda la página ---------- */
  function initReveal() {
    if (!document.body.classList.contains('animations-on')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sections = $$('#MainContent > .shopify-section');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const sec = e.target;
        sec.classList.add('is-revealed');
        // Escalona la aparición de los elementos internos
        $$('[data-animate], .grid > *, .slider > *, .pb__card, .ic, .sq__opt, .bp__item, .review, .accordion', sec).forEach((child, i) => {
          child.style.setProperty('--d', Math.min(i, 8) * 70 + 'ms');
        });
        io.unobserve(sec);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    sections.forEach((sec, i) => {
      const r = sec.getBoundingClientRect();
      if (sec.querySelector('[data-scs], [data-hsx], [data-loopb]')) return; // secciones con scroll propio
      if (i === 0 || r.top < window.innerHeight) { sec.classList.add('is-revealed'); return; }
      sec.classList.add('reveal');
      io.observe(sec);
    });
  }

  /* ---------- Advertorial: barra de lectura + barra fija de compra ---------- */
  function initAdvertorial() {
    const bar = $('[data-read-progress] span');
    const sticky = $('[data-adv-sticky]');
    if (!bar && !sticky) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      const h = document.documentElement.scrollHeight - window.innerHeight;
      const p = h > 0 ? window.scrollY / h : 0;
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      if (sticky) sticky.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.9 && p < 0.97);
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Tira de imágenes: pausa al tocar/arrastrar ---------- */
  function initStrips(root) {
    $$('[data-istrip]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      el.addEventListener('touchstart', () => el.classList.add('is-paused'), { passive: true });
      el.addEventListener('touchend', () => setTimeout(() => el.classList.remove('is-paused'), 2500), { passive: true });
    });
  }

  /* ---------- Anillos de % ---------- */
  function initRings(root) {
    const rings = $$('.pstats__ring', root).filter((r) => !r._init);
    if (!rings.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-on'); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    rings.forEach((r) => { r._init = true; io.observe(r); });
  }

  /* ---------- Utilidad: progreso de scroll de una sección "pinneada" ---------- */
  function scrollProgress(el) {
    const r = el.getBoundingClientRect();
    const total = r.height - window.innerHeight;
    return total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : (r.top < 0 ? 1 : 0);
  }
  function onScrollWhileVisible(el, fn) {
    let ticking = false, active = false;
    const loop = () => { ticking = false; fn(); };
    const handler = () => { if (active && !ticking) { ticking = true; requestAnimationFrame(loop); } };
    new IntersectionObserver(([e]) => { active = e.isIntersecting; if (active) handler(); }).observe(el);
    window.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler);
    fn();
  }

  /* ---------- Showcase con scroll ---------- */
  function initShowcase(root) {
    $$('[data-scs]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const feats = $$('[data-scs-feat]', el);
      const dots = $$('[data-scs-dot]', el);
      const n = Math.max(1, feats.length);
      onScrollWhileVisible(el, () => {
        const p = scrollProgress(el);
        el.style.setProperty('--p', p.toFixed(4));
        const idx = Math.min(n - 1, Math.floor(p * n * 0.999));
        feats.forEach((f, i) => { f.classList.toggle('is-on', i <= idx && p > 0.02); f.classList.toggle('is-current', i === idx); });
        dots.forEach((d, i) => d.classList.toggle('is-on', i <= idx));
      });
    });
  }

  /* ---------- Pasos en scroll horizontal ---------- */
  function initHSteps(root) {
    $$('[data-hsx]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const track = $('[data-hsx-track]', el);
      const bar = $('[data-hsx-bar]', el);
      const size = () => { el.style.height = (track.scrollWidth - window.innerWidth + window.innerHeight) + 'px'; };
      size();
      window.addEventListener('resize', size);
      window.addEventListener('load', size);
      onScrollWhileVisible(el, () => {
        const p = scrollProgress(el);
        const max = Math.max(0, track.scrollWidth - window.innerWidth);
        track.style.transform = `translate3d(${-max * p}px,0,0)`;
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      });
    });
  }

  /* ---------- Palabras que rotan ---------- */
  function initRotators(root) {
    $$('[data-rotator]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const words = $$('span', el);
      if (words.length < 2) return;
      let i = 0;
      setInterval(() => {
        words[i].classList.remove('is-on');
        i = (i + 1) % words.length;
        words[i].classList.add('is-on');
      }, 1800);
    });
  }

  /* ---------- Historias tipo Instagram ---------- */
  function initStories(root) {
    $$('[data-stories]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const slides = $$('[data-story]', el);
      const bars = $$('[data-story-bar]', el);
      const dur = (parseInt(el.dataset.speed, 10) || 5) * 1000;
      let i = 0, start = 0, elapsed = 0, paused = true, raf;
      const show = (n) => {
        i = (n + slides.length) % slides.length;
        slides.forEach((s, j) => s.classList.toggle('is-active', j === i));
        bars.forEach((b, j) => { b.style.width = j < i ? '100%' : '0%'; });
        elapsed = 0; start = performance.now();
      };
      const tick = (now) => {
        if (!paused) {
          const t = elapsed + (now - start);
          if (bars[i]) bars[i].style.width = Math.min(100, (t / dur) * 100) + '%';
          if (t >= dur) show(i + 1);
        }
        raf = requestAnimationFrame(tick);
      };
      const pause = () => { if (!paused) { elapsed += performance.now() - start; paused = true; } };
      const play = () => { if (paused) { start = performance.now(); paused = false; } };
      $('[data-story-next]', el).addEventListener('click', () => { show(i + 1); });
      $('[data-story-prev]', el).addEventListener('click', () => { show(i - 1); });
      let holdTimer;
      el.addEventListener('pointerdown', () => { holdTimer = setTimeout(() => { pause(); el.classList.add('is-held'); }, 180); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((ev) => el.addEventListener(ev, () => { clearTimeout(holdTimer); if (el.classList.contains('is-held')) { el.classList.remove('is-held'); play(); } }));
      new IntersectionObserver(([e]) => { if (e.isIntersecting) play(); else pause(); }, { threshold: 0.5 }).observe(el);
      show(0);
      raf = requestAnimationFrame(tick);
      el._show = show;
    });
  }
  document.addEventListener('shopify:block:select', (e) => {
    const st = e.target.closest && e.target.closest('[data-story]');
    if (st) { const w = st.closest('[data-stories]'); if (w && w._show) w._show($$('[data-story]', w).indexOf(st)); }
  });

  /* ---------- ¿Mito o realidad? ---------- */
  function initMyth(root) {
    $$('[data-mf]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const sec = el.closest('.section');
      const score = sec && $('[data-mf-score]', sec);
      const okEl = sec && $('[data-mf-ok]', sec);
      let ok = 0;
      el.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mf-pick]');
        if (!btn) return;
        const card = btn.closest('[data-mf-card]');
        if (card.classList.contains('is-done')) return;
        const right = btn.dataset.mfPick === card.dataset.answer;
        card.classList.add('is-done', right ? 'is-right' : 'is-wrong');
        btn.classList.add('is-picked');
        const res = $('[data-mf-result]', card);
        if (res) res.textContent = right ? '¡Acertaste!' : 'Casi…';
        if (right) ok++;
        if (score) { score.hidden = false; okEl.textContent = ok; }
        if (navigator.vibrate) navigator.vibrate(right ? 10 : [10, 40, 10]);
      });
    });
  }

  /* ---------- Chat de dudas que se escribe solo ---------- */
  function initChat(root) {
    $$('[data-chat]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const msgs = $$('[data-chat-msg]', el);
      const typing = $('[data-chat-typing]', el);
      const body = $('.cfq__body', el);
      if (window.Shopify && window.Shopify.designMode) { msgs.forEach((m) => m.classList.add('is-in')); return; }
      const run = () => {
        let t = 300;
        msgs.forEach((m, i) => {
          const isBrand = m.classList.contains('cfq__msg--brand');
          if (isBrand) {
            setTimeout(() => { typing.classList.add('is-on'); body.appendChild(typing); }, t);
            t += 900;
          }
          setTimeout(() => {
            if (isBrand) typing.classList.remove('is-on');
            m.classList.add('is-in');
          }, t);
          t += isBrand ? 700 : 600;
        });
      };
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.35 });
      io.observe(el);
    });
  }

  function initAll(root = document) {
    initAnnouncement(root);
    initSliders(root);
    initCountdowns(root);
    initBeforeAfter(root);
    initCounters(root);
    initVideos(root);
    initAnimations(root);
    initFilters(root);
    initProducts(root);
    initStory(root);
    initHotspots(root);
    initReviews(root);
    initPopup(root);
    initDetailGallery(root);
    initInfoTabs(root);
    initBattery(root);
    initQuiz(root);
    initBreakdown(root);
    initVideoReviews(root);
    initStrips(root);
    initRings(root);
    initShowcase(root);
    initHSteps(root);
    initRotators(root);
    initStories(root);
    initMyth(root);
    initChat(root);
  }

  document.addEventListener('DOMContentLoaded', () => { initReveal(); initAll(); initAdvertorial(); Cart.enhance(); });

  /* ---------- Editor de temas de Shopify ---------- */
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const d = e.target.querySelector('.drawer.is-open');
    if (d) closeDrawer(d);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest('.announcement__item');
    if (item) {
      $$('.announcement__item', item.parentElement).forEach((x) => x.classList.remove('is-active'));
      item.classList.add('is-active');
    }
  });
})();
